import { BaseRequests } from "../../../config/BaseRequests";
import { settingsApiEndpoints } from "../api/settings.api";
import { AdminDto, CreateAdminDto, UpdateAdminDto } from "../dto/index.dto";
import { PaginatedResponse } from "../../../shared/dto/pagination.dto";

export class SettingsService {
  static getAdmins = (
    page: number,
    limit: number
  ): Promise<PaginatedResponse<AdminDto>> =>
    BaseRequests.get(settingsApiEndpoints.getAdmins(page, limit));

  static createAdmin = (data: CreateAdminDto): Promise<AdminDto> =>
    BaseRequests.post(settingsApiEndpoints.createAdmin, data);

  static updateAdmin = (id: string, data: UpdateAdminDto): Promise<AdminDto> =>
    BaseRequests.patch(settingsApiEndpoints.updateAdmin(id), data);

  static deleteAdmin = (id: string): Promise<void> =>
    BaseRequests.delete(settingsApiEndpoints.deleteAdmin(id));
}
